/**
 * Genera un identificador único y estable para una cuenta (contrato o solicitud).
 *
 * Las solicitudes pendientes se identifican por `idSolicitud` (prioritario), ya que
 * pueden tener un `contrato` asociado (el contrato al que solicitan acceso) pero
 * aún no están activas. Los contratos activos se identifican por `contrato`.
 * Nunca se usa un índice posicional: el design-system usa este valor como
 * `idTabla_DS` y ids que cambian de posición causan filas duplicadas o borradas
 * incorrectamente al refrescar la grilla.
 *
 * @param {Object} cuenta - Cuenta con `contrato`, `idSolicitud` y/o `estado`
 * @returns {string|number} Identificador estable de la cuenta
 */
export const getIdCuenta = (cuenta) => {
  if (!cuenta) return null
  // Prioridad a idSolicitud: las solicitudes pendientes tienen contrato (al que
  // solicitan) pero deben identificarse por su propio id para no confundirse
  // con el contrato activo del mismo número.
  if (cuenta.idSolicitud !== undefined && cuenta.idSolicitud !== null) return `sol-${cuenta.idSolicitud}`
  if (cuenta.contrato !== undefined && cuenta.contrato !== null) return cuenta.contrato
  return null
}
